"use strict";

angular.module("models").service("GalleryService", function () {
  var that = this;

  that.getDefaultTypesDoc = [{
    value: "other",
    name: "Autre"
  }];
});